export default __webpack_public_path__ + "images/gauge-chart-dummy-140.94dafe5a0a01d3f4b0ccf8c9f8f27d41.svg";